import * as Headless from '@headlessui/react'
import clsx from 'clsx'

export function Fieldset({ className, ...props }) {
  return <Headless.Fieldset {...props} className={clsx('space-y-6', className)} />
}

export function Legend({ className, ...props }) {
  return <Headless.Legend {...props} className={clsx('text-base font-semibold text-zinc-950', className)} />
}

export function FieldGroup({ className, ...props }) {
  return <div {...props} className={clsx('space-y-5', className)} />
}

export function Field({ className, ...props }) {
  return <Headless.Field {...props} className={clsx('space-y-2', className)} />
}

export function Label({ className, ...props }) {
  return <Headless.Label {...props} className={clsx('block text-sm font-medium text-zinc-950', className)} />
}

export function Description({ className, ...props }) {
  return <Headless.Description {...props} className={clsx('text-sm text-zinc-500', className)} />
}

export function ErrorMessage({ className, ...props }) {
  return <Headless.Description {...props} className={clsx('text-sm text-red-600', className)} />
}
